module.exports = __webpack_public_path__ + "static/media/entrada.58b1e49b.jpeg";